// import { createSelector } from 'reselect';

export const getItems = (state:any) => state.accountManager.items;
export const getSettings = (state:any) => state.accountManager.settings;
export const getIsFetching = (state:any) => state.accountManager.isFetching;
export const getIsLoading = (state:any) => state.accountManager.isLoading;
export const getStatus = (state:any) => state.accountManager.status;
